import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_ACTIVITIES_HOST_URL,
  withCredentials: true,
  headers: {
    accept: `application/json`,
  },
});

const setUpInterceptors = (getState, dispatch) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const token = getState()?.auth?.activityAccessToken;
      if (token) {
        config.headers["Authorization"] = `Bearer ${token}`;
      }
      return config;
    },
    (error) => Promise.reject(error)
  );
};

const axiosBaseQuery =
  () =>
  async (
    { url, method, body, params, ...requestOpts },
    { getState, dispatch }
  ) => {
    setUpInterceptors(getState, dispatch);
    try {
      const axiosOptions = {
        url: url,
        method,
        data: body,
        params,
        headers: requestOpts.headers,
      };

      const result = await axiosInstance(axiosOptions);
      return { data: result.data };
    } catch (axiosError) {
      let err = axiosError;
      return {
        error: {
          status: err.response?.status,
          data: err.response?.data || err.message,
        },
      };
    }
  };

export const reportsapigri = createApi({
  reducerPath: "grireportsApi",
  baseQuery: axiosBaseQuery(),
  tagTypes: ["grireports"],
  endpoints: (builder) => ({
    GrigetToken: builder.mutation({
      query: () => ({
        url: `login`,
        method: "POST",
        body: {
          API_KEY: process.env.REACT_APP_ACTIVITIES_HOST_API_KEY,
        },
      }),
      invalidatesTags: ["grireports"],
    }),
    GetReportid: builder.query({
      query: ({ id, token }) => {
        if (!id) {
          return;
        }
        return {
          url: `/gri/reports/${id}`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["grireports"],
    }),
    GetReportItemHistory: builder.query({
      query: ({ reportId, token }) => {
        if (!reportId) {
          return;
        }
        return {
          url: `/gri/reports/${reportId}/report-item/`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["grireports"],
    }),
    AddReportItem: builder.mutation({
      query: ({ reportId, token, payload }) => {
        return {
          url: `/gri/reports/${reportId}/report-item/upsert/`,
          method: "POST",
          body: payload,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      invalidatesTags: ["grireports"],
    }),
    // getCategoryActivities: builder.query({
    // query: ({ token, category, region }) => {
    // if (!region) {
    // return;
    // }
    // return {
    // url: `get_activities?category=${category}&region=${region}`,
    // headers: {
    // Authorization: `Bearer ${token}`,
    // },
    // };
    // },
    // providesTags: ["activities"],
    // }),
    Grireport: builder.mutation({
      query: ({ token, body }) => {
        return {
          url: `/gri/reports`,
          method: "POST",
          headers: {
            Authorization: `Bearer ${token}`,
          },
          body: body,
        };
      },
      invalidatesTags: ["grireports"],
    }),
    Getgrireport: builder.query({
      query: ({ token }) => {
        return {
          url: `/gri/reports`,
          headers: {
            Authorization: `Bearer ${token}`,
          },
        };
      },
      providesTags: ["grireports"],
    }),
    GriDeleteReport: builder.mutation({
      query: (id, token) => ({
        url: `/gri/reports/${id}`,
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      invalidatesTags: ["grireports"],
    }),
    // New endpoint for posting type and FY
    GHGInventory: builder.mutation({
      query: ({ token, body }) => ({
        
        url: `/gri/reports`, // Replace with the correct endpoint path
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
        },
        body:body
      }),
      invalidatesTags: ["grireports"],
    }),
  }),
  
});

export const {
  useGrigetTokenMutation,
  useGrireportMutation,
  useGetReportidQuery,
  useGetReportItemHistoryQuery,
  useAddReportItemMutation,
  useGetgrireportQuery,
  useGriDeleteReportMutation,
  useGetCategoryActivitiesQuery,
  useGHGInventoryMutation, // Add the new hook here

} = reportsapigri;
